// extracted by mini-css-extract-plugin
module.exports = {"TOP_HEIGHT":"32px","root":"Top-module__root___3FLtr","inner":"Top-module__inner___ChSvy"};